export default __webpack_public_path__ + "static/media/dob_calendar.3437386f.svg";